import { IconX, IconArrowRight } from '@tabler/icons-react'

import { CloseButton } from './FeedbackForm'
import { FeedbackType } from './FeedbackSection'

import { Button } from '@/components/shared-components/BUI/Button'
import { Text } from '@/components/shared-components/BUI/Text'
import { Flexbox } from '@/components/shared-components/Flexbox'
import { useBreakpoint } from '@/hooks/useBreakpoint'

export const TypeSelection = ({
  onSelect,
  onClose,
}: {
  onSelect: (type: FeedbackType) => void
  onClose: () => void
}) => {
  const isSmall = useBreakpoint('lg')

  return (
    <Flexbox flexDirection="column" gap="1.5rem">
      {!isSmall && (
        <CloseButton
          variant="ghost"
          icon={<IconX size={16} />}
          onClick={onClose}
        />
      )}

      <Flexbox
        flexDirection="row"
        gap="0.5rem"
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <Flexbox flexDirection="column">
          {!isSmall && <Text variant="heading04">Have feedback?</Text>}
          <Text variant="body03" secondary="_500">
            Help us improve our product, all feedback welcome.
          </Text>
        </Flexbox>
      </Flexbox>

      <Flexbox flexDirection="column" gap="0.5rem">
        {[
          { type: 'issue', icon: '⚠️', label: 'Report an issue' },
          { type: 'idea', icon: '💡', label: 'Suggest an idea' },
          { type: 'other', icon: '💬', label: 'Share anything else' },
        ].map(({ type, icon, label }) => (
          <Button key={type} onClick={() => onSelect(type as FeedbackType)}>
            <Flexbox
              flexDirection="row"
              justifyContent="space-between"
              style={{ width: '100%' }}
              alignItems="center"
            >
              <Text>{icon}</Text>
              <Text>{label}</Text>
              <IconArrowRight size={16} />
            </Flexbox>
          </Button>
        ))}
      </Flexbox>
    </Flexbox>
  )
}
